import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResultSelectionService } from 'src/app/services/result-selection.service';
import { ZipDownloadService } from 'src/app/services/zip-download.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.css']
})
export class DownloadDialogComponent implements OnInit {

  @Input() downloadVisible: boolean = false;
  @Output() closeDialog = new EventEmitter();

  itemCount: number = 0;
  downloadCount: number = 0;
  docMax = 100;
  isDownloading = false;

  constructor(private zipSvc: ZipDownloadService, private selectionSvc: ResultSelectionService) {
  }

  ngOnInit(): void {
    this.docMax = environment.download_files_max;
    this.itemCount = this.selectionSvc.getCount();
    this.selectionSvc.selectedCount$.subscribe(c => { this.itemCount = c; });
    this.selectionSvc.downloadableCount$.subscribe(d => { this.downloadCount = d; })
    this.zipSvc.isDownloading$.subscribe(d => { this.isDownloading = d });
  }

  executeClose() {
    this.closeDialog.emit();
  }

  executeDownload() {
    this.zipSvc.setIsDownloading(true);
    this.zipSvc.getFiles();
    this.closeDialog.emit();
  }

  closeProgressDialog() {
    this.zipSvc.setIsDownloading(false);
  }

  hasLegacySelected() {
    const hasLegacy = this.selectionSvc.legacyItemsSelected();

    return hasLegacy;
  }
}
